import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../global/globals';
import { PaginatedResponse } from '../dtos/paginated';
import {
  GroupPaperSearchResult,
  ReadingListCreateRequest,
  ReadingListDetail,
  ReadingListItemStatus,
  ReadingListSummary,
} from '../dtos/reading-list';

@Injectable({
  providedIn: 'root',
})
export class ReadingListService {
  constructor(
    private httpClient: HttpClient,
    private globals: Globals,
  ) {}

  getReadingLists(groupId: string): Observable<ReadingListSummary[]> {
    return this.httpClient.get<ReadingListSummary[]>(this.baseUri(groupId));
  }

  getReadingList(groupId: string, readingListId: string): Observable<ReadingListDetail> {
    return this.httpClient.get<ReadingListDetail>(`${this.baseUri(groupId)}/${readingListId}`);
  }

  createReadingList(
    groupId: string,
    request: ReadingListCreateRequest,
  ): Observable<ReadingListDetail> {
    return this.httpClient.post<ReadingListDetail>(this.baseUri(groupId), request);
  }

  updateItemStatus(
    groupId: string,
    readingListId: string,
    itemId: number,
    status: ReadingListItemStatus,
  ): Observable<ReadingListDetail> {
    return this.httpClient.patch<ReadingListDetail>(
      `${this.baseUri(groupId)}/${readingListId}/items/${itemId}`,
      { status },
    );
  }

  deleteReadingList(groupId: string, readingListId: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.baseUri(groupId)}/${readingListId}`);
  }

  searchEligiblePapers(
    groupId: string,
    query: string,
    page = 0,
    size = 20,
  ): Observable<PaginatedResponse<GroupPaperSearchResult>> {
    let params = new HttpParams().set('page', page).set('size', size);
    if (query.trim()) {
      params = params.set('q', query.trim());
    }
    return this.httpClient.get<PaginatedResponse<GroupPaperSearchResult>>(
      `${this.baseUri(groupId)}/eligible-papers`,
      { params },
    );
  }

  getPaperContent(groupId: string, pdfId: number): Observable<Blob> {
    return this.httpClient.get(
      `${this.globals.backendUri}/groups/${groupId}/pdfs/${pdfId}/content`,
      { responseType: 'blob' },
    );
  }

  private baseUri(groupId: string): string {
    return `${this.globals.backendUri}/groups/${groupId}/reading-lists`;
  }
}
